<template>
  <div>
    <div class="d-none d-md-block">
      <locations-map @locationActive="setActive" :current-active="currentActive"></locations-map>
    </div>
    <div class="block-locations__items">
      <div v-for="item in items" :key="item.id"
           class="block-locations__item"
           :class="{active: currentActive === item.id}"
           @mouseover="setActive(item.id)">
        <sup class="block-locations__item-sup">{{ item.country }}</sup>
        <h3 class="block-locations__item-title">{{ item.title }}</h3>
        <p class="block-locations__item-content" v-html="item.content"></p>
        <time class="block-locations__item-time">{{ item.current_time }}</time>
      </div>
    </div>
  </div>
</template>

<script>
import {DateTime} from "luxon";
import LocationsMap from "./LocationsMap";

export default {
  name: "Locations",
  components: {LocationsMap},
  props: {
    'rawItems': String,
  },
  data() {
    return {
      currentActive: null,
      intervalHandle: null,
      items: [],
    }
  },
  methods: {
    setActive(id) {
      this.currentActive = id;
    },
    update() {
      const now = DateTime.now();

      this.items.forEach((item) => {
        let zoneTime = now.setZone(item.timezone);

        if (!zoneTime.isValid) {
          return;
        }

        item.current_time = zoneTime.toLocaleString(DateTime.TIME_24_SIMPLE);
      });
    }
  },
  mounted() {
    this.items = JSON.parse(this.rawItems); // Get items from block settings.
    this.update();
    this.intervalHandle = setInterval(this.update, 60000);
  }
}
</script>
